import axios from 'axios';

const apiReason = (err: unknown) => (axios.isAxiosError(err) && (err.response?.data?.error as string | undefined)) || null;

/** The error the admin API returned, or `fallback` when it returned none. */
export const errorMessage = (err: unknown, fallback: string) => apiReason(err) || fallback;

/** Why an admin API request failed: the API's own reason when it gave one, else the HTTP client's. */
export const failureReason = (err: unknown) =>
  apiReason(err) || (err instanceof Error && err.message) || 'the request failed';
